<template>
  <div class="inspection">
    <Card :bordered="false" :padding="10" dis-hover>
      <RadioGroup v-model="curArea" type="button" button-style="solid" @on-change="getFlvByIndexCode">
        <Radio v-for="(item,index) in countryList" :key="index" :label="item.indexCode">{{ item.name }}</Radio>
      </RadioGroup>
      <Button type="primary" @click="goMonitorPoint()" style="margin-left: 20px">监控点位</Button>
    </Card>
    <Card dis-hover>
      <Row>
        <Col :span="12">
          <RadioGroup v-model="gridType" @on-change="changeScreen">
            <Radio :label="4">四分屏</Radio>
            <Radio :label="9">九分屏</Radio>
          </RadioGroup>
          <Checkbox v-model="closeOfflinePlay" @on-change="closeOfflinePlayEvent" style="vertical-align: middle">
            关闭离线设备
          </Checkbox>
        </Col>
        <Col :span="12" style="text-align: right">
          <Button @click="screenToggle" type="text" style="">
            <Icon type="md-expand"/>
            全屏
          </Button>
        </Col>
      </Row>
      <div id="playVideo">
        <div v-if="gridType === 4" style="margin-top: 10px">
          <jessibuca4 ref="jessibuca4" :videolist="videolist" :streamStatusList="streamStatusList"
                      :isFullScreen="isFullScreen" :videonamelist="videonamelist"
                      :cameraTypeList="cameraTypeList" :cameraDetailList="cameraDetailList"></jessibuca4>
        </div>
        <div v-if="gridType === 9" style="margin-top: 10px">
          <jessibuca9 ref="jessibuca9" :videolist="videolist" :streamStatusList="streamStatusList"
                      :isFullScreen="isFullScreen" :videonamelist="videonamelist"
                      :cameraTypeList="cameraTypeList" :cameraDetailList="cameraDetailList"></jessibuca9>
        </div>
      </div>
      <Row>
        <Col :span="24" style="text-align: right">
          <Page
            :total="dataTotal"
            show-total
            show-elevator
            :page-size="pageSize"
            :current-page="currentPage"
            @on-change="pageChange"
          />
        </Col>
      </Row>
    </Card>
  </div>
</template>

<script>
import JessibucaVideo from '@/views/Screen/components/Video/JessibucaVideo.vue'
import Jessibuca4 from '@/views/stereoscopicInspection/components/flvh265-4.vue'
import Jessibuca9 from '@/views/stereoscopicInspection/components/flvh265-9.vue'

export default {
  name: "stereoscopicInspection",
  components: {Jessibuca9, Jessibuca4, JessibucaVideo},
  data() {
    return {
      curArea: null,
      countryList: [],
      gridType: 4,
      dataTotal: 40,
      pageSize: 4,
      currentPage: 1,
      videolist: [],
      streamStatusList: [],
      closeOfflinePlay: true,
      cuinfo: {},
      timer: '',
      timeInterval: 3 * 60 * 1000,
      timeScan: 1 * 60 * 1000,
      lasttime: '',
      openAutoSwitch: 'open',
      isFullScreen: false,
      videonamelist: [],
      cameraTypeList: [],
      cameraDetailList: [],
      // playvideourl: ''//'ws://144.123.135.25:8091/rtp/37140000041327000002_37140000041327000002.live.flv'
    }
  },
  mounted() {
    this.getCountry()
    document.addEventListener('fullscreenchange', (event) => {
      // document.fullscreenElement will point to the element that
      // is in fullscreen mode if there is one. If there isn't one,
      // the value of the property is null.
      if (document.fullscreenElement) {
        console.log(`Element: ${document.fullscreenElement.id} entered full-screen mode.`);
      } else {
        if (this.isFullScreen) {
          this.isFullScreen = false
          this.leaveFullScreen()
        }
        console.log('Leaving full-screen mode.');
      }
    });
  },
  methods: {
    goMonitorPoint(){
      this.$router.push({name: 'monitorPoint'})
    },
    changeScreen() {
      this.pageSize = this.gridType
      this.destoryReverseVideo();
      this.getMonitorPoint()
    },
    getFlvByIndexCode() {
      this.currentPage = 1
      this.destoryVideo();
      this.getMonitorPoint()
    },
    closeOfflinePlayEvent() {
      this.getMonitorPoint()
    },
    //区县
    getCountry() {
      this.$http.get('/api/getLowerLevelDepts').then(res => {
        // console.log(res)
        this.countryList = res.data
        this.curArea = res.data[0].indexCode
        this.$nextTick(() => {
          this.getMonitorPoint()
        })
      })
    },
    getMonitorPoint() {
      let params = {
        unitindexcode: this.curArea,
        streamingstatus: this.closeOfflinePlay ? 'normal' : ''
        // pageNum: this.currentPage,
        // pageSize: this.pageSize
      }
      this.$http.post(`/api/point/monitorPoint?page=${this.currentPage}&&size=${this.pageSize}`, params).then(res => {
        // console.log(res)
        if (res.data.status === '200') {
          let videos = this.formatData(res.data.data.list);
          console.log(videos)
          this.videolist = videos[0];
          this.streamStatusList = videos[1];
          this.videonamelist = videos[2];
          this.cameraTypeList = videos[3];
          this.cameraDetailList = videos[4];
          this.dataTotal = res.data.data.total

          this.$nextTick(() => {
            this.switchStart()
          })
        }
      })
    },
    formatData(data) {
      let videolist = [];
      let streamStatusList = [];
      let videonamelist = [];
      let cameraTypeList = []
      let cameraDetailList = []
      let closeOfflinePlay = this.closeOfflinePlay;
      for (const item of data) {
        item['stream_url'] = `${this.$videoUrl}/rtp/${item['deviceId']}_${item['deviceId']}.live.flv`
        if (item['streamingstatus'] == 'normal') {
          streamStatusList.push('online');
          videolist.push(item['stream_url']);
          videonamelist.push(item['name']);
          cameraTypeList.push(item['cameratype'])
          cameraDetailList.push(item)
        } else {
          if (!closeOfflinePlay) {
            videolist.push(item['stream_url']);
            streamStatusList.push('offline');
            videonamelist.push(item['name']);
          }
        }
      }
      return [videolist, streamStatusList, videonamelist, cameraTypeList, cameraDetailList]
    },
    switchStart() {
      if (this.gridType == '9') {
        this.$refs.jessibuca9.switchStart();
      } else if (this.gridType == '4') {
        this.$refs.jessibuca4.switchStart();
      }
    },
    destoryVideo() {
      if (this.gridType == '9') {
        this.$refs.jessibuca9.batchDestoryVideo();
      } else if (this.gridType == '4') {
        this.$refs.jessibuca4.batchDestoryVideo();
      }
    },
    destoryReverseVideo() {
      if (this.gridType == '9') {
        this.$refs.jessibuca4.batchDestoryVideo();
      } else if (this.gridType == '4') {
        this.$refs.jessibuca9.batchDestoryVideo();
      }
    },
    screenToggle() {
      this.isFullScreen = true;
      this.enterfullscreen();
    },
    enterfullscreen() { //进入全屏
      var docElm = document.getElementById('playVideo')  // 指定容器id
      //W3C
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen()
      }
      //FireFox
      else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen()
      }
      //Chrome等
      else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen()
      }
      //IE11
      else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen()
      }
    },
    exitFullScreen() {
      console.log('in the exit full screen')

    },
    leaveFullScreen() {
      this.isFullScreen = false;
    },
    pageChange(page) {
      this.currentPage = page
      this.getMonitorPoint()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getMonitorPoint()
    },
  }
}
</script>

<style scoped lang="less">
.inspection {
}
</style>
